import te, { useReducer as ne, useRef as E, useEffect as _, useState as y, useMemo as ae } from "react";
import { i18nInstance as re } from "../../i18n/i18n.js";
import { useEnvironment as oe } from "../../common/hooks/environment/useEnvironment.js";
import { PaymentAPI as m } from "../../../../js/payments/paymentApi.js";
import { PaymentUtils as R } from "../../../../js/payments/paymentUtils.js";
import { getPaymentProcess as ie } from "../../../../js/payments/getPaymentProcess.js";
import { Status as ce } from "../../../../common/shared/status.js";
import { PaymentMethodCtx as se } from "../hooks/paymentMethodContext.js";
import { paymentStatusReducer as ue, IDLE_PAYMENT_STATUS as me, isInFlight as le, PaymentStatusKind as de } from "../hooks/paymentStatus.js";
import { usePaymentRedirectVerification as ye } from "../hooks/usePaymentRedirectVerification.js";
import { redirectVerificationToEvent as pe } from "../hooks/redirectVerificationToEvent.js";
function Me(q) {
  const {
    channel: S,
    serviceType: W,
    availableMethods: v,
    locationId: A,
    payerId: M,
    currency: P,
    paymentSessionToken: Y,
    paymentGtwToken: L,
    initialAmount: H,
    initialTip: x,
    initialCashback: F,
    children: Q
  } = q, {
    paymentGatewayBaseUrl: j,
    ablyApiKey: J
  } = oe(), p = ye({
    gatewayToken: L
  }), [f, c] = ne(
    ue,
    me
  ), w = E(f);
  _(() => {
    w.current = f;
  }, [f]);
  const C = E(!1);
  _(() => {
    const n = pe(p);
    n && c(n);
  }, [
    p.status,
    p.orderId,
    p.payment,
    p.error
  ]);
  const s = E(null), k = E(0), g = E({
    amount: H,
    tip: x,
    cashback: F
  }), [I, X] = y(H), [b, Z] = y(x), [D, $] = y(F), [h, O] = y([]), [z, B] = y(null), [K, U] = y(null);
  async function N(n, r, e) {
    var T, a;
    k.current += 1;
    const t = k.current, i = g.current;
    await ((T = s.current) == null ? void 0 : T.destroy()), s.current = null;
    const l = await ie({
      engine: n,
      method: r,
      channel: e,
      locationId: A,
      gatewayUrl: j,
      gatewayToken: L,
      paymentSessionToken: Y,
      ablyApiKey: J,
      amount: i.amount,
      tip: i.tip,
      cashback: i.cashback,
      currency: P,
      payerId: M,
      locale: (a = re) == null ? void 0 : a.resolvedLanguage
    });
    if (t !== k.current)
      return await l.destroy(), null;
    if (s.current = l, g.current !== i) {
      const o = g.current;
      l.updateAmount(o.amount, o.tip, o.cashback);
    }
    return l;
  }
  async function G(n, r) {
    B("initializing");
    try {
      const e = await N(
        n.engine,
        n.methodType,
        n.channel
      );
      if (e === null)
        return;
      await e.initialize(), r !== void 0 && await e.mount(r);
    } catch (e) {
      console.error(e), U({
        canUseWallet: m.THIRD_PARTY_METHODS.includes(n.methodType)
      });
    }
    B(null);
  }
  _(() => {
    (async () => {
      const n = v.map(
        (t) => [t.engine, t.methodType]
      ), r = await R.filterAvailablePaymentMethods(
        n,
        I,
        P
      ), e = v.map((t) => ({ ...t, active: !1 })).filter(
        (t) => t.status === ce.ENABLED && t.channel === S && t.serviceType === W && r.some((i) => i[0] === t.engine && i[1] === t.methodType)
      );
      e.length === 1 && (e[0].active = !0), O(e), e.length === 1 && R.isRedirectEngine(e[0].engine) && await G(e[0]);
    })();
  }, [v]);
  function V(n, r) {
    U(null), O(
      (e) => e.map((t) => ({ ...t, active: t.engine === n && t.methodType === r }))
    );
  }
  const ee = ae(() => {
    const n = h.find((a) => a.active), r = Math.max(0, I + b), e = r !== 0 && Math.max(0, r - D) === 0, t = h.length === 1 && R.isRedirectEngine(h[0].engine);
    async function i(a) {
      if (n === void 0)
        throw new Error("No active payment method available");
      await G(n, a);
    }
    async function l(a) {
      if (C.current || le(w.current) || w.current.kind === de.SUCCEEDED)
        return;
      C.current = !0;
      let o = !1;
      U(null);
      try {
        if (r === 0 && (await N(
          m.PaymentMethodEngine.CASH,
          m.PaymentMethodType.CASH,
          S
        ), V(
          m.PaymentMethodEngine.CASH,
          m.PaymentMethodType.CASH
        )), e && await N(
          m.PaymentMethodEngine.CASHBACK,
          m.PaymentMethodType.UNKNOWN,
          S
        ), s.current === null) {
          c({
            type: "FAILED",
            error: new Error("Payment process not initialized yet"),
            orderId: a.orderId
          });
          return;
        }
        const d = R.isRedirectEngine(
          s.current.getEngine()
        );
        c({
          type: d ? "SUBMIT_REDIRECT" : "SUBMIT_INLINE"
        });
        try {
          const u = await s.current.execute(a, {
            // Inline engines (e.g. Adyen 3DS) render a challenge on their own
            // mount node mid-execute; these toggle the overlay off and back on
            // around it. Redirect engines never invoke them.
            onInteractionRequired: () => c({ type: "REQUIRES_ACTION" }),
            onInteractionResolved: () => c({ type: "ACTION_RESOLVED" })
          });
          d ? o = !0 : c({
            type: "SUCCEEDED",
            payment: u,
            orderId: a.orderId
          });
        } catch (u) {
          c({
            type: "FAILED",
            error: u instanceof Error ? u : new Error("Payment failed"),
            orderId: a.orderId
          });
        }
      } finally {
        o || (C.current = !1);
      }
    }
    function T(a, o, d) {
      var u;
      g.current = {
        amount: a,
        tip: o,
        cashback: d
      }, (u = s.current) == null || u.updateAmount(a, o, d), X(a), Z(o), $(d);
    }
    return {
      isFullCashbackPayment: e,
      isRedirectOnlyPayment: t,
      currency: P,
      amount: I,
      dueAmount: r,
      tip: b,
      cashback: D,
      errors: K,
      submit: l,
      loadingState: z,
      paymentMethods: h,
      activateMethod: V,
      initializePaymentMethod: i,
      updateAmount: T,
      activePaymentMethod: n,
      locationId: A,
      payerId: M,
      paymentStatus: f
    };
  }, [
    P,
    I,
    b,
    D,
    K,
    z,
    h,
    A,
    M,
    f
  ]);
  return /* @__PURE__ */ te.createElement(se.Provider, { value: ee }, Q);
}
export {
  Me as PaymentMethodProvider
};
//# sourceMappingURL=PaymentMethodProvider.js.map
